import { satsSymbol } from "./constants";

export const wallet = "Wallet";
export const gold = "Gold";
export const XAUT = "XAUT";
export const createLNAddressTxt = "Create Speed LN address";
export const setup = "setup";
export const receive = "Receive";
export const send = "Send";
export const sent = "Sent";
export const setupLnAddress = (customText) =>
  `Setup ${customText} Lightning Address`;
export const setupLNAddressMessages = [
  "Generate LN address using your desired username to accept payment.",
  "One-time creation of LN address, can't be updated or deleted.",
];
export const setUpNow = "SETUP YOUR LN ADDRESS";
export const save = "Save";
export const continueTxt = "continue";
export const setUpLnSubMessage =
  "Join now and experience lightning-fast transactions.";
export const setYourUserName = "Set your username";
export const yourLnAddress = (customText) =>
  `Your ${customText} Lightning Address`;
export const userNameAddress = "@speed.app";
export const congratulations = "Congratulations";
export const successMsg = "You have successfully claimed your LN Address.";
export const transaction = "Transactions";
export const viewAllTransactions = "View all transactions";
export const customAmount = "Custom amount";
export const lightning = "Lightning";
export const bitcoin = "Bitcoin";
export const ethereum = "Ethereum";
// export const ethereumLabel = "ethereum";
export const enterAmount = "Enter amount";
export const submit = "Submit";
export const sendMessage = "Add address or Invoice";
export const sendMessageLabel =
  "Send payment to LN address, LN invoices, LNurl pay, Bitcoin address, and USDT address.";
export const sendPlaceholder = "ex. test@tryspeed.com";
export const imageDimensionInvalid = (imgDimension) =>
  `Please choose image with a minimum height and width of ${imgDimension}px`;
export const uploadImageText = ["Drop your QR image here, or ", "Browse"];
export const imageSizeMsg = "max file size 2mb";
export const proceed = "Proceed";
export const sendViaLightning = "Send via lightning";
export const addNote = "ADD NOTE";
export const balance = "Balance";
export const notes = "Note";
export const remove = "Remove";
export const amountTxt = "Amount";
export const estimatedFees = "Estimated fees";
export const totalAmount = "Total amount";
export const sendViaOnChain = "Send via onchain ";
export const invalidQrCode = "Invalid QR code";
export const invalidQrCodeSubMessage =
  "The QR code that was scanned did not include a valid lightning or bitcoin address.";
export const paymentFail = "Payment failed";
export const unableToProcess = "Unable to process";
export const redemptionFail = "Redemption failed";
export const redemptionFailSubMessage =
  "Please reach out to your Lightning URL service provider for further assistance.";
export const paymentFailSubMessage =
  "There was a problem routing this payment on the network.";
export const okay = "Okay";
export const helpUs = "Help us";
export const helpMsg =
  "There could be several reasons for a payment failure. Would you be willing to provide us with additional information to help us resolve the payment issue?";
export const reportSpeedSupport = "Report to Speed support";
export const myAssetsLabel = "My Assets";
export const allAssetsLabel = "All Assets";
export const assets = "Assets";
export const filter = "Filter";
export const loadingMsg = "Loading...";
export const somethingWrong =
  "Something went wrong. Please try again after some time";
export const mfaResendCodeMsg = (fromAuth = false) =>
  `New code sent to your registered mobile number${
    fromAuth ? " and email" : ""
  }.`;
export const resendForgotPwdLinkMsg =
  "Check your email for instructions to reset your password";
export const getStartedMessage =
  "Let’s begin your adventure with Bitcoins & Stablecoins.";
export const signIn = "SIGN IN";
export const signUp = "SIGN UP";
export const registerMessage = "Create an account";
export const createAccount = "Create account";
export const signInHeader = "Sign in with email";
export const signInSubHeader = "Please add email & password to sign in.";
export const emailAddress = "Email address";
export const emailAddressPlaceholder = "Enter your email address";
export const invalidEmailAddress = "Email address is invalid";
export const emailAddressRequired = "Email is required";
export const passwordRequired = "Password is required";
export const password = "Password";
export const passwordPlaceHolder = "Enter your password";
export const forgotPassword = "Forgot Password?";
export const registerHeader = "Sign up with email";
export const registerSubHeader = "Please fill your details to create account.";
export const passwordPolicyMessage =
  "*As a reminder your password must contains:";
export const invalidName = "Please enter valid name";
export const registerStepTwoHeader = "Few more details";
export const registerStepTwoSubHeader =
  "Please fill your details to create account.";
export const fullName = "Full name";
export const namePlaceHolder = "Enter your name";
export const countryLabel = "Country";
export const stateLabel = "State";
export const select = "Select";
export const agreeMsg = ["I agree with ", " and "];
export const termsAndPrivacyMsg = ["Terms of service", "Privacy Policy"];
export const selectCountry = "Select country";
export const selectState = "Select state";
export const search = "Search";
export const loginConsent = "Login Consent";
export const loginConsentMessage = [
  "We have noticed that there is an existing merchant account registered under",
  "Would you like to create a new wallet account?",
];
export const signOut = "Sign out";
export const signingOut = "Signing out";
export const create = "Create";
export const speed = "Speed";
export const twoFactorAuthenticationHeader = "Two-factor authentication";
export const twoFactorAuthenticationSubHeader =
  "We'll text a verification code to this mobile device whenever you sign in to your account.";
export const mobile = "Mobile";
export const carrierRateMsg = "*Carrier rates may apply";
export const sendCode = "Send code";
export const mobileNoPlaceholder = "Enter Mobile number";
export const twoFactorVerificationHeader = "2FA verification";

export const twoFactorVerificationMessage = [
  "Enter the 6-digit code sent to your phone ending with",
  "and email",
];
export const otpWillExpireMsg = "OTP will be expire in";
export const otpNotReceived = "Didn't receive a code?";
export const resend = "Resend";
export const verify = "Verify";
export const verifyEmailHeader = "Verify your email address";
export const verifyEmailSubHeader =
  "In order to start using your Speed wallet account, you need to confirm your email address. If you don't receive an email within a few minutes, then check your spam folder or resend.";
export const checkEmailMsg = "Didn't receive an email?";
export const resendVerificationMsg =
  "Verification link sent to your email address";
export const noOptionsFound = "No options found";
export const forgotPasswordHeader = "Forgot password";
export const forgotPasswordSubHeader =
  "Enter the email address associated with your account, and we'll send you a link to reset your password.";
export const forgotPasswordConfirmationHeader = "Check your email";
export const forgotPasswordConfirmationSubHeader =
  "We've sent an email with reset password instruction. If haven't received an email within few minutes then check your spam folder.";
export const min8Char = "8 characters";
export const upperCaseLetter = "ABC";
export const lowerCaseLetter = "abc";
export const numberCharacters = "123";
export const sessionErrorMessage =
  "Your session has expired. Please login again to continue with the Speed";
export const searchPlaceholder = "Search assets";
export const noResultFound = "No results found";
export const searchTipText = "Search Tips";
export const showAllResult = "Show all result for";
export const suggestedFilterHeaderText = "Suggested Filters";
export const tryAgainText = "Please try again with a different keyword";
export const otherAssetsComingSoon = "Other assets coming soon...";
export const recentTransactions = "Recent Transactions";
export const viewAll = "View all";
export const when = "When";
export const status = "Status";
export const failed = "Failed";
export const completed = "Completed";
export const pending = "Pending";
export const invoice = "Invoice";
// export const lightningLabel = "lightning";
// export const onChainLabel = "onchain";
export const transactionId = "Transaction id";
export const id = "Id";
export const confirmationCount = "Confirmation count";
export const received = "Received";
export const pendingTransaction = "pending transaction";
export const pendingTransactions = "Pending transaction";
export const unconfirmed = "Unconfirmed";
export const receiving = "Receiving...";
export const sending = "Sending...";
export const swapping = "Swapping...";
export const details = "Details";
export const networkFee = "Network Fee";
export const routingFee = "Routing Fee";
export const gasFee = "Gas fee";
export const paidTo = "Paid to";
export const pendingConfirmations = "Pending Transactions";
export const viewAllPendingTransactions = "View all pending transactions";
export const address = "Address";
export const enterCustomAmount = "Enter Custom Amount";
export const sendBtc = "Send BTC";
export const sendAsset = (asset) => `Send ${asset}`;
export const networkFeeInfo =
  "This transaction fee, called a “network fee,” goes to Bitcoin miners, not Speed. These fees incentivize miners to process your transaction and add it to the permanent blockchain.";
export const routingFeeInfo =
  "This transaction fee, called a 'routing fee,' goes to the node processing your transaction, not Speed. These fees encourage nodes to handle transactions quickly.";
export const payingHighFee = "You are paying high fee";
export const payingHighFeeInfo = (
  <>
    <span style={{ color: "#848B9E", fontWeight: "600" }}>Tip:</span> For
    payments like this, Lightning offers a great alternative. It's fast, cheap,
    and avoids high miner fees like the{" "}
    <span style={{ color: "#848B9E", fontWeight: "600" }}>9%</span> on this
    transaction.
  </>
);
export const cancel = "Cancel";
export const attention = "Attention ";
export const insufficientFunds = "Insufficient Funds";
export const addAmountNote = "Add amount / Note";
export const addAmount = "ADD AMOUNT";
export const receiveInfo =
  "Inbound invoice was generated, waiting for it to be paid";
export const invalidAddress = "Please enter a valid address";

export const insufficientBalanceMsg = (fee, showBtcAmount = false) => (
  <>
    Please keep&nbsp;
    {showBtcAmount ? "₿" : satsSymbol}${fee} in Speed wallet for fees.
  </>
);
export const minOneSatRequired = () => <>Minimum {satsSymbol}1 required</>;
export const maxSatsAllowed = () => (
  <>Maximum {satsSymbol}50,00,00,000 allowed</>
);
export const minThousandSatsRequired = () => (
  <>Minimum {satsSymbol}1000 required</>
);
export const minBtcRequired = (amount) => `Minimum ₿${amount} required`;
export const maxBtcAllowed = (amount) => `Maximum ₿${amount} allowed`;
export const minUSDTRequired = "Minimum ₮0.01 required";
export const minStableCoinRequired = (uuid) =>
  `Minimum ${uuid === usdt ? "₮" : "$"}0.5 required`;
export const maximumStableCoins = (uuid) =>
  `Maximum ${uuid === usdt ? "₮" : "$"}10,000`;
export const maximumStableCoinAtReceive = (uuid) =>
  `Maximum ${uuid === usdt ? "₮" : "$"}50,00,000 allowed`;
export const maximumUsdt = "Maximum ₮10,000";
export const maximumUsdtAllowedAtReceive = "Maximum ₮50,00,000 allowed";
export const minRequiredSat = (amount, currency) => (
  <>
    Minimum {currency}
    {amount} Required
  </>
);
export const maxRequiredSat = (amount, currency, isFrmReceiveLnURL = false) => (
  <>
    {isFrmReceiveLnURL ? "Receive" : "Send"} maximum {currency}
    {amount}
  </>
);
export const maxXautAtReceive = "Maximum ℥1 allowed";
export const minXautAtReceive = "Minimum ℥0.0002 allowed";
export const maxXAUTRequired = "Maximum ℥1 allowed";
export const minXAUTRequired = "Minimum ℥0.0002 allowed";
export const noTransactions = "No transactions yet";
export const noTransactionsSubMsg =
  "Once you have completed your first transaction, you can view it here.";
export const paymentReceive = "Payment Received";
export const paymentSent = "Payment Sent";
export const alreadyPaid = "already paid";
export const failureReasonNoRoute = "FAILURE_REASON_NO_ROUTE";
export const paymentProcessingUpdate = "Payment processing update";
export const paymentProcessingUpdateSubMsg =
  "Your payment is being processed; however, it may take some time to complete. You can check transactions history for its updated details.";
export const phoneNumberInputLabel = (label) => `This is not a valid ${label}`;
export const next = "Next";
export const settings = "Settings";
export const fiatCurrency = "Currency";
export const contactsLabel = "Contacts";
export const security = "Security";
export const advanceSettings = "Advance settings";
export const changeAccountName = "Change account name";
export const closeAccount = "Close account";
export const changePassword = "Change password";
export const currentPasswordLabel = "Current password";
export const enterCurrentPasswordPlaceHolder = "Enter current password";
export const newPasswordLabel = "New password";
export const enterNewPasswordPlaceHolder = "Enter new password";
export const confirmPasswordLabel = "Confirm password";
export const enterConfirmPasswordPlaceHolder = "Enter confirm password";
export const confirmPasswordValidate =
  "This password doesn't match. Please try again";
export const passwordSuccess = "Your password has been successfully changed";
export const accountName = "Account Name";
export const closeAccountHeader = "Are you sure you want to close the account?";
export const closeAccountInstructions = [
  "You are requesting the closure of your account. The Speed team will get in touch with you for a fund transfer and other feedback,and the procedure could take up to 15 days.",
  "You can revoke an account closure request any time.",
  "You can still send and receive payments, even after requesting account closure.",
  "Once an account is marked as 'closed', you will no longer be able to access any of its information, as Speed doesn’t keep any copies or backups of your account’s data afterwards.",
  "Also, you won’t be able to send or receive any messages that are already in progress and create new requests.",
];
export const deleteAccountCondition = "Yes, I want to delete my account.";
export const verification = "Verification";
export const verifyItsYou = "Verify it’s you";
export const enterCode = [
  "Enter the 6-digit code sent to your email ",
  "Please use the same 6-digit code, which we have already sent to your email ",
];
export const verificationSubMessage =
  "We need to confirm your password to perform this action.";
export const confirmPassword = "Confirm Password";
export const confirmMsg = "Confirm";
export const requestSubmitted = "Request submitted";
export const requestSubmittedInfo = [
  "Your request to close the account was sent, and we have received it. Our team will look into it further, and within 7 days your account will be deleted from our portal. If you need to get in touch with us, email us at ",
  " going forward.",
];
export const backToHome = "Back to home";
export const supportMail = "support@tryspeed.com";
export const accountCloserInProcess = "Account closer request in process";
export const accountCloserInProcessSubMsg =
  "We are working on your request for an account closer and will get in touch with you as soon as possible";
export const accountRetainMsg =
  "You can always retain the closure request by clicking the below button if you decide to revoke it";
export const requestAccepted = "Request accepted ";
export const accountRequestRevoked =
  "Your account closure request has been revoked.";
export const revokeRequest = "Revoke Request";
export const accountNameChanged =
  "Your account name has been changed successfully";
export const back = "Back";
export const lnurl = "lnurl";
export const sats = "SATS";
export const usdt = "USDT";
export const statementDescriptorMsg = (isWithdraw, accountName) =>
  `Payment ${isWithdraw ? "from" : "to"} ${accountName}`;
export const logoutText = "Logout";
export const profile = "My Profile";
export const firstNameLabel = "First Name";
export const lastNameLabel = "Last Name";
export const firstNamePlaceholder = "Enter first name";
export const lastNamePlaceholder = "Enter last name";

export const failedSendErrorCodes = {
  FAILURE_REASON_NO_ROUTE:
    "We are unable to carry out the transaction because we couldn't locate a suitable route.",
  FAILURE_REASON_INSUFFICIENT_BALANCE:
    "We are unable to carry out the intended activity due to an internal error.",
  FAILURE_REASON_TIMEOUT:
    "We are unable to carry out the intended activity as it took longer than anticipated.",
  FAILURE_REASON_INCORRECT_PAYMENT_DETAILS:
    "We are unable to carry out the intended activity as payment is considered invalid and can no longer be claimed by the recipient.",
  FAILURE_REASON_ERROR: "FAILURE_REASON_ERROR",
};

export const poweredBy = "Powered by";
export const noPendingConfirmations = "No Pending Confirmations";
export const noPendingConfirmationsSubMsg =
  "No unconfirmed transaction found. As those transactions have been confirmed and moved to transactions page.";
export const nowLabel = "Now";
export const userNameNotValid = "Username is not valid.";
export const userNameLengthErrorMsg =
  "Username must be at least 5 characters long";
export const alreadyExistUsername =
  "This username is already taken. Try a different name.";
export const expiredLinkMsg = "This email verification link has expired";
export const expiredLinkSubMsg =
  "If you haven't been able to verify your email, you can try resending again";
export const linkAlreadyVerifiedMsg = "Email Address Verified";
export const linkAlreadyVerifiedSubMsg = [
  "You are all set, your email ",
  "is already verified",
];
export const continueDashboard = "Continue to Dashboard";
export const passwordLinkExpired = "This password reset link has expired";
export const passwordLinkExpiredSubMsg =
  "If you haven't been able to recover your password, you can try resetting your password again";
export const resettingPassword = "Try resetting your password again";
export const newPasswordSubMsg =
  "To change your password, enter the new password below.";
export const maxPaymentMsg = "You can create maximum payment of ₿5.";
export const imageInvalid = "Only .jpeg, .png, .jpg, .jfif images are allowed";
export const imageSizeInvalid = "File size should be less than 2 MB";
export const notQrCode = "Uploaded image is not a QR code.";
export const selectPaymentMode = "Select payment mode";
export const paymentModeInfo =
  "Please choose your preferred payment mode to complete the transaction ";
export const invalidExchangeRate = (currencyCode) =>
  `${currencyCode} currency support is currently unavailable, you can still use another supported currency including BTC or SATS`;
export const signupWithGoogle = "SIGN UP WITH GOOGLE";
export const signupWithApple = "SIGN UP WITH APPLE";
export const signupWithEmail = "SIGN UP WITH EMAIL";
export const signinWithGoogle = "SIGN IN WITH GOOGLE";
export const signinWithApple = "SIGN IN WITH APPLE";
export const signinWithEmail = "SIGN IN WITH EMAIL";
export const loginGetStartedFooter = "Already have an account?";
export const registerGetStartedFooter = "Want to create a new account?";
export const welcomeBack = "Welcome back";
export const errorLabel = "Error";
export const copy = "Copy";
export const noFee = "(No fee)";
export const reset = "Reset";
export const insufficientBalance = "Insufficient Balance";
export const totalAmountToSend = "Total amount to send";
export const earnPointMsg = (sats) =>
  `Earn points worth ~ ${sats} SATS with this transaction`;
export const onChainFeesMsg = (
  <>
    <b>Tip:</b> Choose Lightning transfer! Lightning transactions are instant,
    cost a fraction of the above onchain network fees and are super secure.
  </>
);
export const networkFeeMsg =
  "This transaction fee, called a “network fee,” goes to Bitcoin miners, not Speed. These fees incentivize miners to process your transaction and add it to the permanent blockchain.";
export const speedFeeMsg =
  "A small fee may apply to certain transactions to keep Speed running smoothly. You'll always see the fee upfront, so there are no surprises.";
export const routingFeeMsg =
  "This transaction fee, called a 'routing fee,' goes to the node processing your transaction, not Speed. These fees encourage nodes to handle transactions quickly.";
export const sendMax = "send max";
export const speedFee = "Speed fee";
export const accountFeesInfo =
  "A small fee may apply to certain transactions to keep Speed running smoothly. You'll always see the fee upfront, so there are no surprises.";
export const viewInMemPool = "View in mempool";
export const viewInEtherScan = "View in etherscan";
export const viewInTronScan = "View in tronscan";
export const testNetIdRequired =
  "Required testnet invoice or address to perform transaction.";
export const mainNetIdRequired =
  "Required mainnet invoice or address to perform transaction.";
export const invalidAddressOrInvoice = "Invalid Address/Invoice";
export const invalidLNURL = "Invalid LN URL tag type provided.";
export const invalidLNURLHeader = "Invalid LN URL";
export const invalidAddressSubMsg =
  "Required valid address or invoice to perform transaction";
export const history = "History";
export const rewards = "Rewards";
export const type = "Type";
export const dates = "Dates";
export const apply = "Apply";
export const clearAll = "Clear All";
export const enterValidDateMsg = (isStartDate) =>
  `Please select a valid ${isStartDate ? "start" : "end"} date`;
export const enterMinRequiredDate = (isStartDate, givenYear) =>
  `Please select a ${
    isStartDate ? "start" : "end"
  } date in the year of ${givenYear} or after.`;
export const enterValidateFutureDate = (isStartDate) =>
  `Please select a ${
    isStartDate ? "start" : "end"
  } date less than or equal to today`;
export const greaterEndDateMsg =
  "Please select a end date greater than start date.";
export const minAmount = "Min amount";
export const maxAmount = "Max amount";
export const sendWithHighFee = "Send with high fee";
export const accountStatus = "Account status";
export const accountStatusMsg =
  "Your account permissions are listed below. If anything is restricted, simply complete the required steps or contact Speed Support — we’re here to help you regain full access.";
export const accountRestricted = "Account restricted";
export const checkAccountStatus = "Check account status";
export const captcha = "Captcha";
export const captchaSubMsg =
  "There was a problem routing this payment on the network.";
export const captchaCode = "Captcha Code";
export const captchaCodePlaceholder = "Enter Captcha Code";
export const invalidCaptchaCode = "Invalid Captcha Code";
export const selectYourCountry = "Select your country";
export const additionalInfo =
  "We need additional information from you to improve the security of your account.";
export const invalidEthAddress = "Please enter a valid Ethereum address";
export const gasFeeMsg = `This transaction fee, called a "gas fee", goes to the miners, not Speed. These fees incentivize miners to process your transaction and add it to the permanent blockchain.`;
export const expiredInvoiceMsg =
  "This invoice is already expired. Please request a new one.";
export const paymentPreImage = "Payment preimage";
export const newToSpeedWallet = "New to Speed wallet?";
export const getStartedTxt = (currency) =>
  `Get started by receiving ${currency}.`;
export const receiveNow = "Receive Now";
export const tryAgainOtpMessage =
  "Error message: We're experiencing temporary technical difficulties with our email OTP service. Please try again in a few minutes.";
export const maintenanceScheduledMsg = (date) => `Upcoming maintenance.`;
export const viewDetails = "View details";
export const date = "Date: ";
export const time = "Time: ";
export const maintenanceInfo =
  "* During this period, transactions and app features will be temporarily unavailable. Your pending transactions will be available once we're back. Thanks for your patience!";
export const maintenanceScheduled = "We're under scheduled maintenance";
export const maintenanceScheduledSubMsg =
  "Service is currently under maintenance and will be back soon. Thank you for your patience.";
export const miniAppUnderMaintenance = "Mini app is under maintenance";
export const miniAppUnderMaintenanceSubMsg =
  "We're making improvements to serve you better. The mini app will be back shortly - thanks for your patience!";
export const maxSettleMentTimeTxt = "Max settlement time";
export const maxSettleMentTimeTxtInfo =
  "Your transaction will be settled within this timeframe. Otherwise, the debited amount will be reimbursed back to your account.";
export const settledBy = "Settled by";
export const fromDate = "From Date";
export const toDate = "To Date";
export const currentBalance = "Current Balance";
export const denomination = "Denomination";
export const btc = "BTC";
export const showBalance = "Show Balance";
export const promoHeading = "Have a referral code?";
export const twoStepVerification = "Two-step verification";
export const applyCode = "Apply Code";
export const promoSubtitle =
  "Enter a promo or referral code to receive a bonus after your first transaction.";
export const optional = "Optional";
export const promoLabel = `Promo or referral code (${optional}) `;
export const promoPlaceholder = "Enter promo or referral code";
export const codeApplied = (code) => (
  <>
    <span style={{ color: "#0CAD62" }}>{code} </span>
    has been successfully applied!
  </>
);
export const authenticatingURL = "Authenticating URL";
export const viewCoupons = "View all coupons";
export const applyCoupons = "Apply coupons";
export const noCoupons = "No coupons available";
export const noCouponsMessage =
  "No available coupon codes to apply at the moment.";
export const couponApplied = "Coupon code applied";
export const couponRewardMessage = "Earn cashback, rewards and discounts";
export const enjoyBenefits = "Enjoy the benefits!";
export const moreDetails = "More Details";
export const applyPromo = "Apply promo code";
export const promoCode = "Promo code";
export const promoCodePlaceholder = "Enter promo code";
export const promoCodeSubheader =
  "Have a promo code? Apply it now for special benefits and savings.";
export const happySpending = "Happy Spending!";
export const referFriends = "Refer your friend and earn rewards";
export const promoCodeClaimed = ["Woohoo! 🎉", "Promo code claimed"];
export const profileUpdateSuccessMsg = "Your profile details has been updated.";
export const signOutConfirmationMsg = "Are you sure you want to sign out? ";
export const smsAuthentication = "SMS Authentication";
export const setup2StepVerification = "Setup two-step verification";
export const enable = "Enable";
export const activate = "Activate";
export const addNew = "Add new";
export const captchaSubHeader =
  "Add correct captcha to verify you are not a bot.";
export const verifyingHuman = "Verifying human";

export const promoCodeReward = (reward, assetId) => (
  <>
    You’ve been rewarded with
    <br />
    <span
      style={{
        fontWeight: "bold",
        fontSize: "40px",
      }}
    >
      {reward}
    </span>
    <br />
    {assetId}
  </>
);
export const swap = "Swap";
export const totalBalance = "Total balance";
export const to = "To";
export const swapCurrencyMsg = (currency) =>
  `Please select the payment method you'd like to use to Swap ${currency} for your wallet.`;
export const useMax = "Use max";
export const amountYouPay = "Amount you pay";
export const amountYouGet = "Amount you get";
export const minSwapAmountRequired = (amount, currency) => (
  <>
    Minimum {currency}
    {amount} required
  </>
);
export const maxSwapAmountAllowed = (amount, currency) => (
  <>
    Maximum {currency}
    {amount} allowed
  </>
);
export const swapSuccessFull = "swap successfully ";
export const swapLimitReachedMsg = (count) =>
  `Limit of ${count} swaps reached.`;
export const tryAgainAfter = "Try again after ";
export const swapLimitReachedTxt = "Swap limit reached";
export const usdc = "USDC";
export const rateChangeMsg = "Rate may change slightly during swap";
export const swapFrom = "Swap from";
export const swapTo = "Swap to";
export const payVia = "Pay via";
export const payViaSubMsg =
  "Please select the asset you'd like to use to send the payment.";
export const faqs = "FAQS";
export const unrecognizedAlertMsg = "Unrecognized device alert!";
export const unrecognizedAlertSubMsg = [
  "Login attempt from an unrecognized device.",
  "Please check your email to approve it.",
];
export const checkEmailToApprove =
  "New email has been sent to your registered email address.";
export const awaitingApproval = "Awaiting for approval";
export const deviceAccess = "Device access";
export const deviceApproved = "Device approved!";
export const deviceApprovedMsg =
  "Your new device login has been successfully approved. You can now access your account securely.";
export const createUsdtLnAddress = "Create USDT lightning address";
export const createBtcLnAddress = "Create BTC lightning address";
export const createLnAddress = (currency) =>
  `Create ${currency} lightning address`;
export const verifyMobileHeader = "Mobile number verification";
export const verifyMobileSubHeader =
  "To enhance security of your account, verify your mobile number.";
export const verifyMobileNumber = "Verify mobile number";
export const authenticate = "Authenticate";
export const enterNewPhone = "Enter new phone number";
export const verifyNewPhone = "Verify new phone number";
export const newPhoneNumberSubheader =
  "We'll send a code to your new number to confirm. Ready?";
export const changeNumber = "Change Number";
export const failedToGenerateQr = "Failed to generate QR code";
export const retry = "Retry";
export const close = "Close";
export const SIGN_UP_PAGE = "SIGN_UP_PAGE";
export const LOGIN_PAGE = "LOGIN_PAGE";

export const conversionFeeLabel = "Conversion Fee";
export const conversionFeeInfoMsg =
  "When you pay using a different asset than the one requested, a small fee may apply to cover the conversion. You'll always see the fee upfront, so there are no surprises.";
export const apps = "Apps";
export const myAppsLabel = "My Apps";
export const browseCategoriesTitle = "Browse Category";
export const getBtnTxt = "Get";
export const openBtnTxt = "Open";
export const openAppLabel = "Open App";
export const action = "Action";
export const selectActionTxt = "Please select the appropriate action.";
export const appDetail = "App Detail";
export const shareableUrlTxt = "Shareable URL";
export const aboutTxt = "About";
export const launchAppTerms = [
  "By launching this app, you agree to the ",
  "Terms & Conditions of Speed Apps.",
];
export const appCategoryTxt = "App category";
export const supportEmailTxt = "Support email";
export const browse = "Browse";
export const allLabel = "All";
export const noMiniAppFoundTitle = "No Mini Apps Found!";
export const noMiniAppFoundDescription =
  "We couldn't find any mini apps matching your search or category selection. Please try a different keyword or explore other categories.";
export const confirmRemoval = "Confirm Removal!";
export const removalConfirmationMsg =
  "Are you sure you want to delete it? It will no longer be available for new and existing users.";
export const copyUrl = "Copy Url";
export const termsOfUse = "Terms Of Use";
export const privacyPolicy = "Privacy Policy";
export const fullScreen = "Full screen";
export const limits = "Limits";
export const limitInfoDesc = (plan) => {
  let toBeUpgradedPlan;
  if (plan?.toLowerCase() === "verified") {
    toBeUpgradedPlan = "upgrade to our Premium plan.";
  } else if (plan?.toLowerCase() === "premium") {
    toBeUpgradedPlan = "contact Speed support.";
  } else {
    toBeUpgradedPlan = "upgrade to our Verified plan.";
  }

  return `You're currently on the ${
    plan || "Base"
  } plan. To modify these limits, ${toBeUpgradedPlan}`;
};
export const upgradeNow = "Upgrade Now";
export const upgradeKycText =
  "Upgrade to Verified by completing KYC to unlock USD deposits.";
export const daily = "Daily";
export const weekly = "Weekly";
export const asset = "Asset";
export const usedOutofMax = "(Used / Max)";
export const limited = "Limited";
export const unlimited = "Unlimited";
export const downloadApp = "Download App";
export const navigationForAppDownload =
  "Navigate to: Settings → Subscriptions.";
export const appDownloadHint =
  "To increase your limit or manage your subscription, please download the Speed Wallet app or open it on your mobile device.";
export const addYourFirstContact = "Add your first contact";
export const addYourFirstContactSubMsg =
  "Add people or wallets you interact with often.";
export const addContact = "Add Contact";
export const noContactsFoundSubMsg = "We are unable to find the contacts.";
export const editContact = "Edit Contact";
export const name = "Name";
export const enterName = "Enter name";
export const enterAddress = "Enter Address (BTC, USDT, USDC)";
export const paymentMethod = "Payment method";
export const deleteContactMsg =
  "Are you sure you want to delete this contact? This will also remove all its addresses, and it will no longer be available in your contacts.";
export const deleteContact = "Delete Contact";
export const deleteTxt = "Delete";
export const addNewAddress = "Add new address";
export const addToContacts = "Add to contacts";
export const addToContactsMsg =
  "Please select whether to add this to an existing contact or a new contact.";
export const existing = "Existing";
export const deleteAddress = "Delete Address";
export const deleteAddressMsg =
  "Are you sure you want to delete this address from the contact? It will no longer be available in your contact.";
export const contactsDetailsLabel = "Contact Details";
export const newTag = "New";
export const disable = "Disable";
export const authenticatorApp = "TOTP Authenticator";
export const authenticatorMsg =
  "Set up time-based one-time codes using Google, Microsoft, or Apple Authenticator to generate secure login codes.";
export const recommended = "Recommended";
export const authAppCodeSubtitle =
  "Enter the 6-digit code generated by the Authenticator app.";
export const contactSupport = "Contact support";
export const setupAuthAppMsg = (
  <>
    Secure your account with a one-time passcode (OTP) using the Google
    Authenticator app.
  </>
);
export const setupAuthenticatorApp = "Set up TOTP Authenticator";
export const verificationCode = "Verification code";
export const gAuthGuideline =
  "*Make sure to back up this QR code or key securely. You’ll need it if you change or lose your device. You must verify the code to complete setup.";
export const authAppSteps = [
  "Download/Open Authenticator app.",
  <>
    Tap +, then select{" "}
    <span style={{ fontWeight: "bold" }}>Scan a QR code</span> or{" "}
    <span style={{ fontWeight: "bold" }}>Enter a setup key.</span>
  </>,
  "Either scan the QR code or use the key below to add your account:",
];
export const smsAuthenticationMsg =
  "Enable two-step verification with your mobile number.";
export const useAnotherMethod = "Use another method";
export const selectMethod = "Select method";
export const choosePreferredVerificationMethod =
  "Please choose your preferred verification method to complete two-factor authentication.";
export const useAnotherWay = "Use another way";
export const selectAuthSubtitle =
  "Use the method below to verify your identity.";
export const needAnyHelp = "Need any help? ";
export const swapConvert = "Swap/Convert";
export const deposit = "Deposit";
export const ggc = "GGC";
export const noDataAvailable = "No data available";
export const play = "PLAY";
export const increaseLimitLabel = "Increase Limits";
export const confirmPayment = "Confirm Payment";
export const paymentFor = "Payment for ";
export const viaSpeedWallet = "via Speed wallet";
export const amountIncludesText = "(Includes network and speed fees.)";
export const confirmText = "Confirm";
export const recentSentLabel = "Recent sent";
export const payViaMsg =
  "Select the asset of your choice to complete the payment.";
export const dateFormatLabel = "Date Format";
export const selectDateFormat = "Select Date Format";
export const selectCurrency = "Select Currency";
export const viewInSolScan = "View in solscan";
export const viewInTonScan = "View in tonviewer";
export const baseFee = "Base fee";
export const baseFeeMsg =
  "This minimum transaction fee, called a “base fee”, goes to the network, not Speed. It’s required to accept and process your transaction on the blockchain.";
export const lnPaymentWarning = (currency) =>
  `This invoice accepts ${currency} or BTC via Lightning and always settles in ${currency}.`;
export const ethPaymentWarning = (currency) =>
  `Send only ${currency} via ERC20 to this address. Other tokens will be lost.`;
export const trxPaymentWarning = (currency) =>
  `Send only ${currency} via TRC20 to this address. Other tokens will be lost.`;
export const solPaymentWarning = (currency) =>
  `Send only ${currency} via Solana (SPL) to this address. Other tokens will be lost.`;
export const tonPaymentWarning = (currency) =>
  `Send only ${currency} via TON to this address. Other tokens will be lost.`;
export const transactionDetails = "Transaction Details";
export const addressLabel = "Address (BTC, USDT, USDC)";
export const account = "Account";
export const accountDetails = "Account details";
export const clear = "Clear";
export const appNotAvailable = "App is no longer available.";
export const checkLimits = "CHECK LIMITS";
export const limitExhaustedMsg = (limitType) => `${limitType} limit exhausted`;
export const paidSuccessfullyTxt = "Paid Successfully";
export const popupCloseText = (count) =>
  `This popup will close in ${count} seconds…`;
export const limit = "Limit";
export const failedToLoadData = "Failed to load the data";
export const limitErrorTxt =
  "Sorry for inconvenience. We're currently facing an issue. Please try again later.";
export const countLimit = (used, total) => (
  <>
    <span style={{ color: "grey" }}>{used}</span>/{total} times
  </>
);
export const usd = "USD";
export const cash = "CASH";
export const requestStatement = "Request statement";
export const request = "REQUEST";
export const periodLabel = "Time Period";
export const advanceFilters = "Advance filters";
export const format = "Format";
export const amountRange = "Amount range";
export const transactionType = "Transaction type";
export const dateOrder = "Date order";
export const fromLabel = "From";
export const validStartAmountMsg = "Enter start amount";
export const validEndAmountMsg = "Enter end amount";
export const validEndAmountGreaterStartAmountMsg =
  "Enter end amount greater than start amount";
export const transactionSource = "Transaction source";
export const requestInProgress = "Request in progress";
export const requestProgressMsg =
  "We've received your statement request. You'll be notified via email when it's ready for download.";
export const payToTxt = "Pay to";
export const redeemText = "Redeem";
export const paymentFrom = "Payment from ";
export const redeemedSuccessfullyText = "Redeemed Successfully!";
export const networkFeeExceedMsg =
  "Network fees exceed 5% of the transaction amount.";
export const paymentMethodNotSupportedText = `This payment method isn't supported for your account. Please choose another one to continue.`;
export const documentFormat = "Document format";
export const accountSuspendedHeader = "Account Suspended";
export const accountSuspendedSubMsg =
  "Your account has been suspended. Please contact support for more details.";
export const memoRequired = "Network Requires MEMO";
export const transferSecureMsg = "Your transfer is protected and compliant";
export const selectAsset = "Select asset";
export const memoRequiredMsg = (
  <>
    Heads up! This network needs a MEMO. Enter the MEMO <b>as a note -</b> some
    platforms call it Tag, ID, Label or Remarks
  </>
);
export const addNoteTxt = "Add note";
export const enable2FA = "Enable 2FA";
